var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-none px-0",attrs:{"solo":"","dense":"","text":"","dark":"","rounded":"","color":"primary","height":"auto"},on:{"click":_vm.back}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v(" mdi-arrow-left ")]),_c('span',{staticClass:"text-subtitle-2"},[_vm._v(" Volver ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }